export default __webpack_public_path__ + "static/media/heightmap.06f0e056.png";